<template>
	<div>
		<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 101 !important">
			<div class="dialog" style="background-color: #eeeeee">
				<div class="dialog-header">
					<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("new-variable") }}</span>
					<div style="margin-left: auto; margin-right: 0px">
						<md-button @click="$emit('close')" class="md-icon-button" style="margin-right: -5px">
							<md-icon style="color: white">close</md-icon>
						</md-button>
					</div>
				</div>

				<div
					class="dialog-body"
					:style="{ height: height - 278 + 'px' }"
					style="width: 100%; overflow-y: scroll"
				>
					<variables-form
						:variable="item"
						:error="error"
						:editable="true"
						:reset="reset"
						@uniqueName="handleErr"
					/>
				</div>
				<div class="dialog-footer">
					<div style="margin-left: auto; margin-right: 0px">
						<md-button class="cancel" @click="$emit('close')">{{ $t("cancel") }}</md-button>
						<md-button class="add" @click="handleAdd" :disabled="errUnique">
							<i class="el-icon-loading" v-if="loading" />
							<span>{{ $t("add") }}</span>
						</md-button>
					</div>
				</div>
			</div>
		</md-dialog>
	</div>
</template>

<script>
import { mapActions } from "vuex"
import VariablesForm from "@/modules/datas/variables/variables-components/variables-form.vue"

export default {
	components: { VariablesForm },
	name: "variables-add",
	props: ["show"],
	data() {
		return {
			loading: false,
			errUnique: false,
			item: {
				custom_field_value: {
					value: ""
				},
				level: undefined,
				name: undefined,
				rules: {
					computed_rules: undefined,
					list: undefined
				},
				type: undefined
			},
			error: [],
			height: window.innerHeight,
			reset: false
		}
	},
	methods: {
		...mapActions({
			doAdd: "variable/doAdd"
		}),

		handleErr(val) {
			this.errUnique = val
		},

		handleAdd: function () {
			var payload = { ...this.item }
			this.saving = true

			var filtered_rules = {}
			for (const [key, value] of Object.entries(payload.rules)) {
				if (value != undefined && value !== "")
					if (
						!Array.isArray(value) ||
						(Array.isArray(value) && value.length) ||
						(Array.isArray(value) && value.length == 1 && Array.isArray(value[0]) && value[0].length)
					)
						//toglie le stringhe vuote
						//toglie gli array vuoti (list: []), e gli array con un elemento array vuoto (computed_rules: [[]])
						filtered_rules[key] = value
			}

			payload.rules = JSON.stringify(filtered_rules)

			this.add(payload)
		},

		async add(payload) {
			const response = await this.doAdd(payload)
			if (response) {
				this.reset = true
				this.$notification("success", this.$t("save-successful"), "", 5000)
				this.$emit("add", this.item)
			} else this.$notification("error", this.$t("save-error"), "", 0)

			this.saving = false
			this.$emit("close")
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-dialog";
</style>
